export const doAsync = (apiCall, asyncAction, ctx) => {
  ctx.commit(asyncAction + "Pending");
  return apiCall()
    .then(response => {
      ctx.commit(asyncAction + "Success", response);
      return response;
    })
    .catch(error => {
      ctx.commit(asyncAction + "Failure", error);
      console.error("asyncError " + error);
      return error;
    });
};

export default {
  doAsync
};
